const initialState = {
  // These properties are used in the initial setup of the loan
  loans: [],
  memberInfo: {},
  loansLoaded: false,
  internalAccounts: [],
  internalAccountsLoaded: false,
  // Tracks whether the person record has successfully been created after payment type selection
  recordCreated: false,
  // Additional detail endpoint response
  selectedLoanAdditionalDetails: {},
  // Loan info and eligibility specific to skip a pay
  selectedLoanSkipInfo: {},
  // Respone from recurring validation endpoint
  recurringValidation: { loading: false },
  // Response from payoff check endpoint
  payoffCheck: {},
  // Debit card payment response
  debitResponse: {},
  // Internal transfer payment response
  internalResponse: {},
  // Skip a pay denial reasons for display in modal if declined
  skipDenialReasons: [],
  // Skip a pay debit payment response
  skipDebitResponse: {},
  // Skip a pay post response
  skipPostResponse: {},
  // Card type for debit card skip review page
  skipCardType: "",
  // Ach payment response
  paymentResponse: {},
  // Ach post date endpoint response
  achPostDate: null,
  // Tracks if we have encountered an error in the authenticated payments flow
  hasError: false,
};

// Typically I would avoid creating a reducer of this size by breaking it up into smaller reducers where possible
// But in this case I think there is some value in having all the information specifically relating to auth
// payments located in one place. The reducer below is very generally in the order in which these actions would be called
// and I've tried to specify as much as possible in comments

export function authPayment(state = initialState, action) {
  switch (action.type) {
    // Cases for setting up a session and displaying loan list
    case "BEGIN_AUTH_SESSION":
      return state;
    case "AUTH_GET_LOANS":
      return state;
    case "AUTH_SET_LOANS":
      return {
        ...state,
        loans: action.loansResponse.LoanList,
        memberInfo: {
          memberName: action.loansResponse.MemberName,
          email: action.loansResponse.Email,
        },
        loansLoaded: true,
      };
    case "AUTH_CLEAR_LOANS":
      return { ...state, loans: [] };
    // Cases for getting and setting the available internal transfer accounts after the initial call to get the list of loans
    case "AUTH_GET_INTERNAL_ACCOUNTS":
      return state;
    case "AUTH_SET_INTERNAL_ACCOUNTS":
      return { ...state, internalAccounts: action.internalAccounts, internalAccountsLoaded: true };
    case "AUTH_CLEAR_INTERNAL_ACCOUNTS":
      return { ...state, internalAccounts: [] };
    // Creates person record when the user selects a payment type
    case "AUTH_CREATE_RECORD":
      return state;
    case "AUTH_RECORD_CREATED":
      return { ...state, recordCreated: true };
    case "AUTH_CLEAR_RECORD_CREATED":
      return { ...state, recordCreated: false };
    // Sets response from additional details endpoint after user selects a payment type and a record is created
    case "AUTH_SET_ADDITIONAL_DETAILS":
      return { ...state, selectedLoanAdditionalDetails: action.selectedLoanAdditionalDetails };
    // Cases for standard internal transfers
    case "AUTH_SAVE_INTERNAL":
      return state;
    case "AUTH_INTERNAL_SAVED":
      return { ...state, internalResponse: action.internalResponse };
    case "AUTH_SUBMIT_INTERNAL":
      return state;
    // Cases for standard debit payments
    case "AUTH_SAVE_DEBIT":
      return state;
    case "AUTH_DEBIT_SAVED":
      return { ...state, debitResponse: action.debitResponse };
    case "AUTH_SUBMIT_DEBIT":
      return state;
    // Cases for standard ach payments
    case "AUTH_SUBMIT_ACH":
      return state;
    case "AUTH_PAYMENT_SUBMITTED":
      return { ...state, paymentResponse: action.paymentResponse };
    // Cases for authenticated skip a pay
    case "AUTH_SKIP_DEBIT_SUBMITTED":
      return { ...state, skipDebitResponse: action.skipDebitResponse };
    case "AUTH_POST_SKIP":
      return state;
    case "AUTH_SKIP_SUBMITTED":
      return { ...state, skipPostResponse: action.skipPostResponse };
    case "AUTH_GET_SKIP_INFO":
      return state;
    case "AUTH_SKIP_INFO_LOADED":
      return { ...state, selectedLoanSkipInfo: action.selectedLoanSkipInfo };
    case "AUTH_SKIP_DENIAL_REASONS_LOADED":
      return { ...state, skipDenialReasons: action.skipDenialReasons };
    case "CLEAR_AUTH_SKIP_DENIAL_REASONS":
      return { ...state, skipDenialReasons: [] };
    case "GET_CARD_TYPE":
      return state;
    case "SET_CARD_TYPE":
      return { ...state, skipCardType: action.skipCardType };
    // Used for calculating the post date for standard ach payments
    case "AUTH_CALC_POST_DATE":
      return { ...state };
    case "AUTH_SET_POST_DATE":
      return { ...state, achPostDate: action.achPostDate };
    // Called when determining whether an entered payment would trigger a paydown/payoff, and
    // switches the type ro paydown/payoff if necessary
    case "AUTH_CHECK_PAYOFF":
      return { ...state };
    case "AUTH_PAYOFF_CHECKED":
      return { ...state, payoffCheck: action.payoffCheck };
    // Cases for validating recurring payments
    case "AUTH_VALIDATE_RECURRING":
      return { ...state, recurringValidation: { ...state.recurringValidation, loading: true } };
    case "AUTH_SET_RECURRING_VALIDATION":
      return { ...state, recurringValidation: { ...action.recurringValidation, loading: false } };
    case "AUTH_CLEAR_RECURRING_VALIDATION":
      return { ...state, recurringValidation: {} };
    // Action that calls payoff generation saga
    case "AUTH_GENERATE_PAYOFF_LETTER":
      return { ...state };
    // Case for refinance redirect from specific loan cards
    case "AUTH_REFINANCE_REDIRECT":
      return { ...state };
    // Cases for error handling and resetting reducer
    case "SET_AUTH_ERROR":
      return { ...state, hasError: true };
    case "CLEAR_AUTH_ERROR":
      return { ...state, hasError: false };
    case "RESET_AUTH_FLOW":
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authPayment.js